import BaseMixin from "@/mixins/http/Base";
import { Component } from "vue-property-decorator";
import { API_ENDPOINT } from "@/constants";
import AgentCompanyAssociationDuplicate from "@/models/Agents/AgentCompanyAssociationDuplicate";

export const enum AgentCompanyAssociationDuplicateMixinTags {
  GetDuplicates = "get_duplicates",
  AssociateManyIdSelected = "associate_many_id_selected",
}

export type AssociateManyIdSelectedPayload = {
  selectedId: string | number;
  targetIds: string[];
};

@Component
export default class AgentCompanyAssociationDuplicateMixin extends BaseMixin {
  getDuplicates(
    slug: string,
    tag: string,
    params: any
  ): Promise<AgentCompanyAssociationDuplicate[]> {
    const queryString = this.paramsToQueryString(params);
    const url =
      API_ENDPOINT +
      `/${slug}/agents/association_duplicates.json?${queryString}`;

    return this.$store.dispatch("http/request", {
      tag: tag,
      url: url,
      method: "GET",
    });
  }

  associateManyIdSelected(
    slug: string,
    tag: string,
    payload: AssociateManyIdSelectedPayload[]
  ): Promise<AgentCompanyAssociationDuplicate[]> {
    const url =
      API_ENDPOINT +
      `/${slug}/agents/association_duplicates/associate_many_id_selected.json`;

    const data = { selectedDuplicates: payload };

    return this.$store.dispatch("http/request", {
      tag: tag,
      url: url,
      method: "POST",
      data,
    });
  }
}
